import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, withDefaults, watch, onMounted } from 'vue';
import Swiper from 'swiper';
import { SwiperManager } from '../SwiperManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwiperPagination',
  props: {
    swiperManager: null,
    maxBullets: { default: 10 }
  },
  setup(__props: any) {

const props = __props as { swiperManager: SwiperManager, maxBullets: number }


const numSlides = ref<number>(0);
const realIndex = ref<number>(0);
const activeIndex = ref<number>(0);
const bulletWidthPx = 12;

const translateX = computed<number>(() => {
    let firstBulletToShow = 0;
    if (realIndex.value > props.maxBullets - 1) {
        firstBulletToShow = realIndex.value - props.maxBullets + 1;
    }
    return -bulletWidthPx * firstBulletToShow;
});

const viewportWidth = computed<number>(() => {
    return Math.min(props.maxBullets, numSlides.value) * bulletWidthPx;
});

const updateIndexes = () => {
    const swiper = props.swiperManager.swiper.value;
    if (swiper) {
        numSlides.value = swiper.slides.length;
        realIndex.value = swiper.realIndex;
        activeIndex.value = swiper.activeIndex;
    }
};

const init = (swiper: Swiper) => {
    if (swiper) {
        updateIndexes();
        swiper.on('slideChange', () => {
            updateIndexes();
        });
        swiper.on('update', () => {
            updateIndexes();
        });
    }
};

watch(props.swiperManager.swiper, (swiper) => {
    if (swiper) {
        init(swiper);
    }
});

onMounted(() => {
    const swiper = props.swiperManager.swiper.value;
    if (swiper) {
        init(swiper);
    }
});

const slideTo = (index: number) => {
    const swiper = props.swiperManager.swiper.value;
    if (swiper) {
        if (swiper.params && swiper.params.loop) {
            swiper.slideToLoop(index);
        } else {
            swiper.slideTo(index);
        }
    }
};

return { __sfc: true,props, numSlides, realIndex, activeIndex, bulletWidthPx, translateX, viewportWidth, updateIndexes, init, slideTo }
}

})